// extracted by mini-css-extract-plugin
export default {"header":"_0aYKV0G1--DeliveryAddressModalHeader_header__VIFQE"};